export default "<app-zoom-level [(zoomLevel)]=\"zoomLevel\" [min]=\"zoomMin\" [max]=\"zoomMax\"></app-zoom-level>\r\n<svg><g></g></svg>\r\n"